import { mapActions, mapGetters } from "vuex";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import {showDeleteDialogAlert, showViewDialogAlert} from "@/utils/DialogAlertHelper";
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";

import ProjectsService from "@/services/server/ProjectsService.js";
import LeadsService from "@/services/server/LeadsService.js";
import UsersService from "@/services/server/UsersService";
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import UsersServiceFirebase from '@/services/firebase/Users/UsersService';

import Propecting from "@/components/Projects/Prospecting/Prospecting.vue"
import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import ProjectMessagesDialog from '@/components/Projects/ProjectMessages/ProjectMessagesDialog.vue';

import ProjectMessagesService from "@/services/firebase/ProjectsMessages/ProjectMessagesService.js";
import InfiniteLoading from 'vue-infinite-loading';
import {StatusReference} from "@/pages/Projects/Utils/StatusConstants.js";

export default {
	name: "Projetos",

	components: {
		Propecting,
		DatePickerDialog,
		InfiniteLoading,
		ProjectMessagesDialog,
	},

	data: () => ({
		openProspection: false,
		newLead: {},
		dialog: false,
		is_created: false,
		is_loading: true,
		isValidForm: false,
		messagesDialog: false,
		showDropdownMessage: {},
		showDropdownComment: {},
		selectedProjectId: null,
		selected_project: {},
		messages: [],
		responseTextArea: [],
		editingStates: {},
		editedMessage: null,
		editedComment: null,
		is_loading_modal_messages: {},
		is_loading_message: false,
		is_loading_new_message: false,
		index: -1,
		showPendingReview: false,
		statusFilterMenu: false,
		selectedStatusColor: null,
		statusColors: [
			{ color: '#ee7b6b', name: 'Vermelho - Reprovado' },
			{ color: '#7ca3de', name: 'Azul - Rascunho' },
			{ color: '#69c871', name: 'Verde - Aprovado' },
			{ color: '#f0a26e', name: 'Laranja - Pendente' },
			{ color: '#d1c300', name: 'Amarelo - Em Análise' }
		],
		form: {
			project_name: null,
			lead_document: null,
			id_franchisee: null,
		},
		type_lead_documents: [
			'CPF',
			'CNPJ',
			'Matrícula',
		],
		type_lead_documents_masks: {
			'CPF': "###.###.###-##",
			'CNPJ': "##.###.###/####-##",
			'Matrícula': null,
		},
		type_lead_document_selected: 'CPF',
		rankMapper: [
			{ text: "Super Admin", value: 0 },
			{ text: "Admin", value: 1 },
			{ text: "Franqueado", value: 2 },
			{ text: "Cliente", value: 4 },
			{ text: "Associado", value: 5 }
		],
		headers: [
			{ text: 'Nome do Projeto', value: "project_name", },
			{ text: 'Cliente', value: 'lead_name', },
			{ text: 'Franqueado', value: 'franchisee_name'},
			{ text: 'Documento (CPF/CNPJ)', value: 'lead_document', },
			{ text: 'Passo', value: 'currentStepFormatted', },
			{ text: 'Status', value: 'lastLogMessage', },
			{ text: 'Status ADM', value: 'currentStatusADM', },
			{ text: 'Data de Criação', value: 'created_at_formatted', },
			{ text: 'Estado', value:'uf'},
			{ text: 'Cidade', value: 'city'},
			{ text: 'Dias Ativo', value: 'running_time', align: 'center' },
			{ text: 'Chat', value: 'has_message', align: 'center' },
			{ text: 'Ações', value: 'actions', sortable: false },
		],
        items: [],
		message: null,
		message_response: null,
		chatLoading: false,
		startDateDialog: false,
		startDatePicker: [],
		maxStartDate: '',
		searchField: '',
		searchOptions: [
			'Projeto',
			'Cliente',
			'Documento (CPF/CNPJ)',
			'Franqueado',
			'Status'
		],
		searchOptionSelected: 'Cliente',
		franchisee_list: [],
		franchisee_selected: null,
		project_steps_list: [
			{
				id: UtilsProjects.STEPS.PROSPECTING,
				name: 'Prospecção',
				icon: require("@/assets/projects/fz_magnify.png"),
			},
			{
				id: UtilsProjects.STEPS.DIAGNOSTIC,
				name: 'Waterscan',
				icon: require("@/assets/projects/WaterScan.png"),
			},
			{
				id: UtilsProjects.STEPS.APPROVAL,
				name: 'Aprovação',
				icon: require("@/assets/projects/fz_approval.png"),
			},
			{
				id: UtilsProjects.STEPS.CLOSING,
				name: 'Fechamento',
				icon: require("@/assets/projects/fz_deal.png"),
			},
			{
				id: UtilsProjects.STEPS.CONTRACTS,
				name: 'Contratos',
				icon: require("@/assets/projects/fz_docs.png"),
			},
			{
				id: UtilsProjects.STEPS.MATERIALS,
				name: 'Entrega',
				icon: require("@/assets/projects/fz_shipping.png"),
			},
			{
				id: UtilsProjects.STEPS.INSTALLATION,
				name: 'Waterfix',
				icon: require("@/assets/projects/WaterFix.png"),
			},
			{
				id: UtilsProjects.STEPS.FINISH,
				name: 'Finalizado',
				icon: require("@/assets/projects/fz_approval.png"),
			},
		],
		project_steps_selected: {
			id: 'general',
			name: 'Geral',
		},
		project_franchisee_list: [],
		selectedChips: [
		],
		lastDocSnapshot: null,
		resetInfiniteHandler: true,
		show_messages_dialog: false,
		show_comment_dialog: false,
		loadingNewProject:false,
	}),

	computed: {
		...mapGetters([
			"getCurrentUserData",
			"getFranqueados",
			"getCurrentUserRank",
		]),
		formattedDateRange() {
			if (!this.startDatePicker.length) {
				return 'Filtrar por período';
			}

			const formattedDateStart = Utils.formatDateDayJs(this.orderStartDate()[0], 'DD/MM/YYYY');
			const formattedDateEnd = Utils.formatDateDayJs(this.orderStartDate()[1], 'DD/MM/YYYY');

			if (this.startDatePicker.length === 1) {
				return `Data inicial: ${formattedDateStart}`;
			}

			if (formattedDateStart === formattedDateEnd) {
				return `${formattedDateStart}`;
			}

			return `${formattedDateStart} - ${formattedDateEnd}`;
		},
		isFranchisee() {
			return this.getCurrentUserRank === "Franqueado";
		},
		filteredHeaders() {
			let headers = []

			if(this.isFranchisee) {
				headers = [
					{ text: 'Nome do Projeto', value: "project_name" },
					{ text: 'Cliente', value: 'lead_name' },
					{ text: 'Documento (CPF/CNPJ)', value: 'lead_document' },
					{ text: 'Passo', value: 'currentStepFormatted' },
					{ text: 'Status', value: 'lastLogMessage' },
					{ text: 'Data Status', value: 'date_formatted_franchisee' },
					{ text: 'Data de Criação', value: 'created_at_formatted' },
					{ text: 'Dias Ativo', value: 'running_time', align: 'center' },
					{ text: 'Chat', value: 'has_message', align: 'center' },
					{ text: 'Ações', value: 'actions', sortable: false }
				]
			}else{
				headers = [
					{ text: 'Nome do Projeto', value: "project_name"},
					{ text: 'Cliente', value: 'lead_name'},
					{ text: 'Franqueado', value: 'franchisee_name'},
					{ text: 'Documento (CPF/CNPJ)', value: 'lead_document'},
					{ text: 'Passo', value: 'currentStepFormatted'},
					{ text: 'Status ADM', value: 'currentStatusADM'},
					{ text: 'Data Status', value: 'date_formatted_adm' },
					{ text: 'Data de Criação', value: 'created_at_formatted'},
					{ text: 'Estado', value:'uf'},
					{ text: 'Cidade', value:'city'},
					{ text: 'Dias Ativo', value: 'running_time', align: 'center' },
					{ text: 'Chat', value: 'has_message', align: 'center' },
					{ text: 'Ações', value: 'actions', sortable: false },
				]
			}

			return headers;
		  },
		  filteredSearchOptions() {
			return this.isFranchisee
			  ? this.searchOptions.filter((option) => option !== "Franqueado")
			  : this.searchOptions;
		  },
		getItems() {
			let items = this.items
			items = this.applyFilter();

			let search = ''
			function filterFranchisee(id_franchisee) {
				if (id_franchisee == 'general') return
				items = items.filter(
					(item) => {
						return item.id_franchisee === id_franchisee
					}
				);
			}
			function filterProjectStep(steps) {
				if (steps.length === 0) return;

				items = items.filter((item) => {
					const currentStep =  item.steps.find(({isCurrentStep})=> isCurrentStep === true)
					return currentStep? steps.includes(currentStep.name) : true
				});
			}
			function searchProject(search, searchText) {
				searchText = Utils.defaultSpace(searchText)
				items = items.filter(
					(item) => {
						if (searchText == '') return true
						if (!item[search]) return false
						return Utils.defaultSpace(item[search]).toLowerCase().indexOf(searchText.toLowerCase()) > -1
					}
				);
			}
			filterProjectStep(this.selectedChips)
			switch (this.searchOptionSelected) {
				case 'Projeto':
					search = 'project_name'
					searchProject(search, this.searchField)
					break;
				case 'Cliente':
					search = 'lead_name'
					searchProject(search, this.searchField)
					break;
				case 'Documento (CPF/CNPJ)':
					search = 'lead_document'
					searchProject(search, this.searchField)
					break;
				case 'Franqueado':
					search = 'franchisee_name'
					searchProject(search, this.searchField)
					break;
				case 'Status':
					search = 'lastLogMessage'
					searchProject(search, this.searchField)
					break;
				default:
					searchProject(null, '')
			}
			return items
		},
	},

	methods: {
		async infiniteHandler($state) {
			if(this.resetInfiniteHandler){
				this.resetInfiniteHandler = false
				$state.reset()
				return $state.loaded()
			}
			this.is_loading_modal_messages = {action: 'edit'}
            const { result, messages, lastDocSnapshot } = await ProjectMessagesService.paginationCallsMessagesByProject(this.lastDocSnapshot,this.selectedProjectId)
            this.lastDocSnapshot = lastDocSnapshot
			this.messages.push(...messages)
			
			await this.addMessagesToArray()
            if (result > 0) return $state.loaded()
            return $state.complete()
        },
		async addMessagesToArray(){
			const senders_id = new Set();
			
			this.messages.map(message => {
				senders_id.add(message.sender_id)
				
				if (message.comments && Array.isArray(message.comments)) {
					message.comments.forEach(comment => {
						senders_id.add(comment.sender_id)
					});
				}
			});
			
			const users_data = await UsersServiceFirebase.getUsersByIdList(Array.from(senders_id))
			
			this.messages = this.messages.map(message => {
				const user_message = users_data.find(user => user.id === message.sender_id);
				
				if (message.updated_at) {
					message = {...message,
						formatted_updated_at: this.formatDateOnMessages(message.updated_at)};
					}
					
					message = {
						...message,
						user_rank: this.getUserRank(user_message?.rank),
						image_url: user_message?.metadata?.imageURL
					}
					
					if (message.comments && Array.isArray(message.comments)) {
						message.comments = message.comments.map(comment => {
							const user_comment = users_data.find(user => user.id === comment.sender_id);
							
							if (comment.updated_at) {
								comment = {
									...comment,
									formatted_updated_at: this.formatDateOnMessages(comment.updated_at)
								};
							}
							comment = {
								...comment,
								user_rank: this.getUserRank(user_comment.rank),
								image_url: user_comment.metadata.imageURL
							}
							return comment;
						});
					}
					
					return message;
			})

			this.initAndResetDropdowns();
			this.is_loading_modal_messages = false;

			// Atualiza apenas o projeto atual como lido
			const currentProject = this.getItems.find(project => project.id_doc === this.selectedProjectId);
			if (currentProject) {
				currentProject.has_message = false;
			}

			if(this.messages.length) await this.insertReaderOnProject();
		},
		getOptions(item) {
			const options = [];

			const id_user = this.getCurrentUserData.id
			const user_rank = this.getCurrentUserRank

			const canEdit = item.sender_id === id_user;
			const canDelete =
				((user_rank === 'Admin' || user_rank === 'Super Admin') || item.sender_id === id_user) ||
				(user_rank === 'Franqueado' && item.sender_id === id_user);

			if (canEdit) {
				options.push({
					text: 'Editar',
					icon: 'mdi-pencil',
					color: 'primary'
				});
			}
			if (canDelete) {
				options.push({
					text: 'Deletar',
					icon: 'mdi-delete',
					color: 'error'
				});
			}

			return options;
		},
		loadingAction(actionType) {
			return this.is_loading_modal_messages && this.is_loading_modal_messages.action === actionType
		},
		isDisabled(actionType, item) {
			const currentIndex = this.calculatedIndex(item);
			return this.is_loading_modal_messages && 
				   this.is_loading_modal_messages.action === actionType && 
				   this.index === currentIndex;
		},
		calculatedIndex(item) {
			return this.getItems.findIndex(project => project === item);
		},
		initAndResetDropdowns() {
			this.responseTextArea = Array(this.messages.length).fill(false);
			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = this.messages.map(message => {
				return message.comments ?
				Array(message.comments.length).fill(false) :
				[];
			});
		},
		getColor(userRank) {
			const rankColors = {
				"Super Admin": '#182B57',
				"Admin" : '#182B57',
				"Franqueado": '#1976D2',
				"Cliente": '#1976D2',
				"Associado": '#1976D2'
			};
			return rankColors[userRank] || '#808080'; // Cor padrão se não encontrado
		},
		async updateProjects() {
		},
		async openMessageDialog(id_project) {
			this.resetInfiniteHandler = true;
			this.lastDocSnapshot = null;
			this.selectedProjectId = id_project;
			this.selected_project = this.getItems.find(project => project.id_doc === id_project) || {};
			this.messages = [];
			this.messagesDialog = true;
			this.show_messages_dialog = true;
			this.index = this.getItems.findIndex(project => project.id_doc === id_project);
			this.is_loading_modal_messages = { action: 'load' };
			await this.loadMessages();
			this.is_loading_modal_messages = false;
		},
		async insertReaderOnProject(){
			const project = this.getItems.find((project) => project.id_doc === this.selectedProjectId)
			if (!project.readers?.some(reader => reader.reader_id === this.getCurrentUserData.id))  {
				const project_readers = project.readers || [];
				const reader = {
					reader_id: this.getCurrentUserData.id,
					read_at: new Date()
				}

				project_readers.push(reader)

				await ProjectsService.updateProject(this.selectedProjectId, {
					readers: project_readers
				})

			}
		},
		async clearReadersOnProject(){
			const readers = [{
				reader_id: this.getCurrentUserData.id,
				read_at: new Date()
			}]

			await ProjectsService.updateProject(this.selectedProjectId, {
				readers: readers
			})
		},
		getUserRank(rank) {
			try {
				return this.rankMapper.find(m => m.value === rank)?.text || 'Desconhecido';
			} catch (error) {
				console.error("Erro ao buscar rank do usuário:", error);
				return 'Desconhecido';
			}
		},
		formatDateOnMessages(date) {
			if (date['seconds'] !== undefined && date['nanoseconds'] !== undefined) {
				return Utils.formatDateDayJs(date['seconds'] * 1000, 'DD/MM/YYYY [às] HH:mm');
			} else {
				return Utils.formatDateDayJs(new Date(date), 'DD/MM/YYYY [às] HH:mm');
			}
		},
		toggleDropdownComment(messageIndex, commentIndex) {
			if (this.showDropdownComment[messageIndex]?.[commentIndex]) {
				this.$set(this.showDropdownComment[messageIndex], commentIndex, false);
			} else {
				this.handleCloseAll();
				this.$set(this.showDropdownComment[messageIndex], commentIndex, true);
			}
		},
		toggleDropdownMessage(messageIndex) {
			const isOpen = this.showDropdownMessage[messageIndex];
			if (isOpen) {
				this.$set(this.showDropdownMessage, messageIndex, false);
			} else {
				this.handleCloseAll();
				this.$set(this.showDropdownMessage, messageIndex, true);
			}
		},
		handleCloseAll() {
			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = Array(this.messages.length).fill().map(() => []);
		},
		async addMessage(){
			if (this.message && this.message.trim()) {
				let messageTemplate = {
					created_at: new Date(),
					sender_name: this.getCurrentUserData.name,
					sender_id: this.getCurrentUserData.id,
					message: this.message.trim(),
					id_project: this.selectedProjectId,
					readers: [{reader_id: this.getCurrentUserData.id, read_at: new Date()}]
				}

				this.is_loading_new_message = true;
				messageTemplate.id_doc = await ProjectMessagesService.createMessage(messageTemplate);
				const user_data = await UsersServiceFirebase.getUsersById(messageTemplate.sender_id);
				await this.clearReadersOnProject();
				messageTemplate.comments = [];
				messageTemplate.image_url = user_data?.metadata?.imageURL;
				messageTemplate.user_rank = this.getUserRank(user_data?.rank);

				this.messages.unshift(messageTemplate);
				this.handleCloseAll();
				this.cleanStates();
				this.message = null;
				this.is_loading_new_message = false;
				showSuccessSnackBar("Mensagem adicionada com sucesso!")
			}
		},
		toggleResponse(index) {
			this.message_response = null
			const actualStatus = this.responseTextArea[index]
			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = Array(this.messages.length).fill().map(() => Array().fill(false));
			this.responseTextArea = Array(this.messages.length).fill(false);
			this.$set(this.responseTextArea, index, !actualStatus)
		},
		async handleSendResponse(index) {
			if (!this.message_response) {
				return;
			}

			if (this.messages[index]) {
				this.is_loading_message = true;
				let responseTemplate = {
					sender_id: this.getCurrentUserData.id,
					sender_name: this.getCurrentUserData.name,
					comment: this.message_response.trim(),
					created_at: new Date(),
					id_message: this.messages[index].id_doc,
					readers: [{reader_id: this.getCurrentUserData.id, read_at: new Date()}]
				}

				responseTemplate.id_doc = await ProjectMessagesService.createComment(responseTemplate);
				const user_data = await UsersServiceFirebase.getUsersById(responseTemplate.sender_id);
				await this.clearReadersOnProject();
				responseTemplate.image_url = user_data?.metadata?.imageURL;
				responseTemplate.user_rank = this.getUserRank(user_data?.rank);

				this.messages[index].comments = this.messages[index].comments || [];
				this.messages[index].comments.unshift(responseTemplate);

				showSuccessSnackBar("Mensagem adicionada com sucesso!")
			}

			this.$set(this.responseTextArea, index, false)
			this.message_response = null
			this.is_loading_message = false;
		},
		cleanStates() {
			this.editingStates = {};
		},
		isEditingMessage(messageIndex) {
			return this.editingStates[messageIndex] === 'message';
		},
		isEditingComment(messageIndex, commentIndex) {
			return this.editingStates[`${messageIndex}-${commentIndex}`] === 'comment';
		},
		toggleEditMode(messageIndex, commentIndex = null, type = 'message') {
			this.cleanStates();
			const key = type === 'message' ? messageIndex : `${messageIndex}-${commentIndex}`;

			if (this.editingStates[key]) {
				this.editingStates[key] = null;
			} else if (type === 'message') {
				this.editingStates[key] = type;
				this.editedMessage = this.messages[messageIndex].message;
			} else {
				this.editingStates[key] = type;
				this.editedComment = this.messages[messageIndex].comments[commentIndex].comment;
			}
		},
		async handleClick(item, index) {
			const message = this.messages[index];
			this.$set(this.showDropdownMessage, index, false);

			if (item.text === 'Deletar') {
				showDeleteDialogAlert("Deseja deletar essa mensagem? essa ação é irreversível!", async () => {
					await ProjectMessagesService.deleteMessage(message.id_doc);
					this.messages = this.messages.filter(msg => msg.id_doc !== message.id_doc);
					showSuccessSnackBar("Mensagem deletada com sucesso!")
				})
			} else if (item.text === 'Editar') {
				this.toggleEditMode(index)
			}
		},
		handleCommentClick(item, messageIndex, commentIndex) {
			const message = this.messages[messageIndex];
			const comment = message.comments[commentIndex];

			this.$set(this.showDropdownComment[messageIndex], commentIndex, false);

			if (item.text === 'Deletar') {
				showDeleteDialogAlert("Deseja deletar esse comentário? essa ação é irreversível!", async () => {
					const result = await ProjectMessagesService.deleteComment(message.id_doc, comment.id_doc);
					if (result) {
						message.comments = message.comments.filter(msg => msg.id_doc !== comment.id_doc);
						showSuccessSnackBar("Mensagem deletada com sucesso!")
					}
				})
			} else if (item.text === 'Editar') {
				this.toggleEditMode(messageIndex, commentIndex, 'comment');
			}
		},
		async handleEditSave(messageIndex, commentIndex, type = 'message') {
			let message = this.messages[messageIndex];
			this.is_loading_message = true;
			if (type === 'message') {
				const [status, responseSave] = await ProjectMessagesService.updateMessage(message.id_doc, this.editedMessage.trim());
				if (status) {
					await this.clearReadersOnProject();
					this.messages[messageIndex] = {
						...responseSave,
						...message,
						message: this.editedMessage,
						formatted_updated_at: this.formatDateOnMessages(responseSave.updated_at)
					}
					showSuccessSnackBar("Mensagem editada com sucesso!")
				}
			} else if (type === 'comment') {
				const comment = message.comments[commentIndex];
				const [status, responseSave] = await ProjectMessagesService.updateComment(message.id_doc, comment.id_doc, this.editedComment.trim());
				if (status) {
					await this.clearReadersOnProject();
					message.comments[commentIndex] = {
						...responseSave,
						...comment,
						comment: this.editedComment,
						formatted_updated_at: this.formatDateOnMessages(responseSave.updated_at)
					}
					showSuccessSnackBar("Mensagem editada com sucesso!")
				}
			}
			this.is_loading_message = false;
			this.cleanStates();
		},
		getCurrentStatus(logMessage) {
			const parts = logMessage.split(' - ');
			return parts[0] ? parts[0].trim() : '';
		},
		getColorByOldStatus(status) {
			switch (this.getCurrentStatus(status || '')) {
				case 'Aprovada':
				case 'Aprovado':
					return 'success';
				case 'Reprovado':
				case 'Reprovada':
					return 'error';
				case 'Revisão':
				case 'Revisão Solicitada':
				case 'Alteração Solicitada':
					return 'warning';
				case '':
					return '';
				default:
					return 'info'; // Cor azul para Outros
			}
		},
		getChipColor(status,oldStatus) {
			// if(!status || !oldStatus) {
			// 	console.log("-------------------------")
			// 	console.log(status,oldStatus)
			// 	return 'info'
			// }
			return typeof status === 'number' ? StatusReference[status].color : this.getColorByOldStatus(oldStatus)
		},
		getChipStatus(status,oldStatus) {
			return typeof status === 'number' ? StatusReference[status].name : oldStatus
		},
		orderStartDate() {
			if (this.startDatePicker[0] > this.startDatePicker[1]) {
				return [
					this.startDatePicker[1],
					this.startDatePicker[0]
				]
			}
			return [
				this.startDatePicker[0],
				this.startDatePicker[1]
			]
		},
		startDateCalendar() {
			const date = Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>");
			this.startDateDialog = true
			this.maxStartDate = date
		},
		async selectDateCalendar(date) {
			this.startDatePicker = date
			this.startDateDialog = !this.startDateDialog
			if (this.lastValueSelect && this.franchisee_id) {
				this.loading.main_table = true
				this.data_table = []
				let calls = await firebase.getCallsBy(this.lastValueSelect[0], this.getSelectDateTime())
				this.data_table = await this.filterCalls(calls, this.lastValueSelect[1].select)
				await this.valuesTableSum(this.data_table)
				await this.summarySum(this.data_table)
			}
		},
		clearDateFilter(event) {
			event.stopPropagation();
			this.startDatePicker = [];
		},
		applyFilter() {
			let items = [...this.items];

			// Apply date range filter
			if (this.startDatePicker.length === 2) {
				const startDate = new Date(this.orderStartDate()[0] + "T00:00:00");;
				const endDate = new Date(this.orderStartDate()[1] + "T23:59:59");

				items = items.filter((item) => {
					const itemDate = new Date(item.created_at);
					return itemDate >= startDate && itemDate <= endDate;
				});
			}

			// Apply status color filter
			if (this.selectedStatusColor) {
				items = items.filter((item) => {
					const status = this.isFranchisee ? 
						item.currentStatusFranchisee : 
						item.currentStatusADM;
					return this.isStatusWithColor(status, this.selectedStatusColor);
				});
			}

			return items;
		},
		isStatusWithColor(status, color) {
			const selectedStatus = StatusReference[status];
			return selectedStatus && selectedStatus.color === color;
		},
		toggleStatusFilter() {
			this.statusFilterMenu = !this.statusFilterMenu;
		},
		selectStatusColor(color) {
			this.selectedStatusColor = this.selectedStatusColor === color ? null : color;
			this.statusFilterMenu = false;
		},
		isPendingReviewStatus(status) {
			const selectedStatus = StatusReference[status];
			return selectedStatus && selectedStatus.color === '#f0a26e';
		},
		togglePendingReview() {
			this.showPendingReview = !this.showPendingReview;
		},
		checkCurrentStep(item){
			const step = item.find(({isCurrentStep})=> isCurrentStep === true)
			return step? UtilsProjects.TranslateSteps[step.name] : " - / -"
		},
		customSort(items, sortBy, sortDesc) {
			if (sortBy[0] === 'project_name') {
			  return items.sort((a, b) => {
				const nameA = a.project_name.toLowerCase();
				const nameB = b.project_name.toLowerCase();
				if (nameA < nameB) return sortDesc[0] ? 1 : -1;
				if (nameA > nameB) return sortDesc[0] ? -1 : 1;
				return 0;
			  });
			}
			else if (sortBy[0] === 'lead_name') {
			  return items.sort((a, b) => {
				const nameA = a.lead_name.toLowerCase();
				const nameB = b.lead_name.toLowerCase();
				if (nameA < nameB) return sortDesc[0] ? 1 : -1;
				if (nameA > nameB) return sortDesc[0] ? -1 : 1;
				return 0;
			  });
			}
			else if (sortBy[0] === 'lead_document') {
			  return items.sort((a, b) => {
				const nameA = a.lead_document.toLowerCase();
				const nameB = b.lead_document.toLowerCase();
				if (nameA < nameB) return sortDesc[0] ? 1 : -1;
				if (nameA > nameB) return sortDesc[0] ? -1 : 1;
				return 0;
			  });
			}
			else if (sortBy[0] === 'created_at_formatted') {
			  return items.sort((a, b) => {
				const nameA = new Date(a.created_at).getTime();
				const nameB = new Date(b.created_at).getTime();
				if (nameA < nameB) return sortDesc[0] ? 1 : -1;
				if (nameA > nameB) return sortDesc[0] ? -1 : 1;
				return 0;
			  });
			}
			return items;
		},
		openDialog() {
			this.dialog = true
			this.form = {
				project_name: null,
				lead_document: null,
				id_franchisee: null,
			}
			this.type_lead_document_selected = 'CPF'
		},
		closeDialog() {
			this.dialog = false
		},
		selectProjectTypeFilter(stepProject) {
			const index = this.selectedChips.indexOf(stepProject);
			if (index > -1) this.selectedChips.splice(index, 1)
			else this.selectedChips.push(stepProject);
		},
		isSelectedChip(id) {
			return this.selectedChips.includes(id);
		},
		closeFunc() {
			this.openProspection = false
		},
		async updateProjectMessageStatus(projectId) {
			if (projectId) {
				const projectIndex = this.items.findIndex(project => project.id_doc === projectId);
				if (projectIndex !== -1) {
					// Set has_message to false since the user has now viewed the messages
					this.$set(this.items[projectIndex], 'has_message', false);
				}
			}
		},
		async createProject() {
			if (this.getCurrentUserRank === "Franqueado") this.form.id_franchisee =  this.project_franchisee_list[0].id

			if (!this.$refs.newProjectForm.validate()) return
			this.loadingNewProject = true

			const [status, lead] = await LeadsService.searchLeadByDocument(
				this.form.lead_document,
				this.form.id_franchisee.id,
			)
			if (!status) {
				this.loadingNewProject = false
				return
			}
			// Carregar o lead ou criar um novo
			
			if (!lead) {
				this.openProspection = true
				this.newLead = {
						id_franchisee: this.getCurrentUserRank === "Franqueado" ? this.form.id_franchisee : this.form.id_franchisee.id,
						lead_document: this.form.lead_document,
						project_name: this.form.project_name,
						type_lead_document_selected: this.type_lead_document_selected,
					}
			} else {
				const project = this.getItems.find((({id_lead}) => id_lead === lead.id_doc))
				showViewDialogAlert(`Projeto em andamento para esse cliente, deseja visualizar?`,() => this.navigateProject(project))
			}
			this.loadingNewProject = false
		},
		ruleRequired() {
			return Rules.required()
		},
		ruleString(isRequired = false, max = 64) {
			return Rules.string(isRequired, 1, max)
		},
		ruleCPF(isRequired) {
			return Rules.cpf(isRequired)
		},
		ruleCNPJ(isRequired) {
			return Rules.cnpj(isRequired)
		},
		navigateProject(item) {
			this.$router.push(`/projects/${item.id_doc}`)
		},
		formatDate(date){
			if(!date)return ''
			return Utils.formatDate(new Date(date) , "<dd>/<MM>/<YYYY>")
		},
		updateURLFilters() {
			const query = {}

			if (this.searchField) query.searchText = this.searchField
			if (this.searchOptionSelected) query.searchOption = this.searchOptionSelected
			if (this.selectedChips.length) query.steps = this.selectedChips.join(',')
			if (this.startDatePicker.length) {
				query.startDate = this.startDatePicker[0]
				query.endDate = this.startDatePicker[1]
			}

			this.$router.replace({
				query
			}).catch(() => {})
		},
		initializeFiltersFromURL() {
			const query = this.$route.query;

			const filterMapping = {
				searchText: {
					prop: 'searchText',
					callback: (value) => this.searchField = value
				},
				searchOption: {
					prop: 'searchOption',
					callback: (value) => this.searchOptionSelected = value
				},
				steps: {
					prop: 'steps',
					callback: (value) => this.selectedChips = value.split(',').filter(Boolean)
				},
				startDate: {
					prop: 'startDate',
					callback: (value, endDate) => {
						if (value && endDate) {
							this.startDatePicker = [value, endDate];
						}
					}
				}
			};

			Object.entries(filterMapping).forEach(([param, { prop, callback }]) => {
				const value = query[param];
				if (value || (prop === 'startDate' && query[param] && query.endDate)) {
					callback(value, query.endDate);
				}
			});

			this.applyFilter();
		},
		openMessagesDialog(projectId) {
			this.show_messages_dialog = true;
		},
		async loadMessages() {
			this.is_loading_modal_messages = {action: 'edit'}
			const { result, messages, lastDocSnapshot } = await ProjectMessagesService.paginationCallsMessagesByProject(this.lastDocSnapshot,this.selectedProjectId)
			this.lastDocSnapshot = lastDocSnapshot
			this.messages.push(...messages)
			await this.addMessagesToArray()
		},
		async addMessagesToArray(){
			this.messages.map(message => {
				message.formatted_updated_at = this.formatDateOnMessages(message.updated_at)
				if(message.comments) {
					message.comments.map(comment => {
						comment.formatted_updated_at = this.formatDateOnMessages(comment.updated_at)
					})
				}
			})
		},
		async loadMoreMessages() {
			this.is_loading_modal_messages = {action: 'loadMore'}
			const { result, messages, lastDocSnapshot } = await ProjectMessagesService.paginationCallsMessagesByProject(this.lastDocSnapshot,this.selectedProjectId)
			this.lastDocSnapshot = lastDocSnapshot
			this.messages.push(...messages)
			await this.addMessagesToArray()
			this.is_loading_modal_messages = false;
			if(this.messages.length) await this.insertReaderOnProject();
		},
		isActionLoading(actionType) {
			return this.is_loading_modal_messages && this.is_loading_modal_messages.action === actionType
		},
		isActionLoadingForIndex(actionType, currentIndex) {
			return (this.index !== -1) && this.is_loading_modal_messages && (this.index !== currentIndex || this.is_loading_modal_messages.action === actionType)
		},
		resetMessagesArrays() {
			this.responseTextArea = Array(this.messages.length).fill(false);
			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = this.messages.map(message => {
				return Array(message.comments ? message.comments.length : 0).fill(false);
			});
		},
		async openMessages() {
			this.messages = []
			this.messagesDialog = true
			await this.loadMessages()
			// await ProjectMessagesService.addReaderToMessages(messageIdsList, this.getCurrentUserData.id);
		},
		formatDateOnMessages(date) {
			if (!date) return '';
			const d = new Date(date);
			return d.toLocaleDateString('pt-BR', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
			});
		},
		async createMessage() {
			if (!this.newMessage.trim()) return;
			
			const messageTemplate = {
				id_project: this.selectedProjectId,
				message: this.newMessage.trim(),
				created_by: this.getCurrentUserData.id,
				created_at: new Date(),
				updated_at: new Date(),
				comments: []
			};

			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = Array(this.messages.length).fill().map(() => []);
			
			messageTemplate.id_doc = await ProjectMessagesService.createMessage(messageTemplate);
			messageTemplate.formatted_updated_at = this.formatDateOnMessages(messageTemplate.updated_at);
			
			this.messages.unshift(messageTemplate);
			this.newMessage = '';
			
			this.showDropdownMessage = Array(this.messages.length).fill(false);
			this.showDropdownComment = Array(this.messages.length).fill().map(() => Array().fill(false));
			this.responseTextArea = Array(this.messages.length).fill(false);
		},
		async createComment(index) {
			if (!this.newComment.trim() || !this.messages[index]) return;
			
			const responseTemplate = {
				id_message: this.messages[index].id_doc,
				comment: this.newComment.trim(),
				created_by: this.getCurrentUserData.id,
				created_at: new Date(),
				updated_at: new Date()
			};
			
			responseTemplate.id_doc = await ProjectMessagesService.createComment(responseTemplate);
			responseTemplate.formatted_updated_at = this.formatDateOnMessages(responseTemplate.updated_at);
			
			this.messages[index].comments = this.messages[index].comments || [];
			this.messages[index].comments.unshift(responseTemplate);
			this.newComment = '';
		},
		editMessage(messageIndex) {
			this.editedMessage = this.messages[messageIndex].message;
		},
		editComment(messageIndex, commentIndex) {
			this.editedComment = this.messages[messageIndex].comments[commentIndex].comment;
		},
		async deleteMessage(index) {
			const message = this.messages[index];
			if (!message) return;
			
			await ProjectMessagesService.deleteMessage(message.id_doc);
			this.messages = this.messages.filter(msg => msg.id_doc !== message.id_doc);
		},
		async deleteComment(messageIndex, commentIndex) {
			const message = this.messages[messageIndex];
			if (!message || !message.comments) return;
			
			const comment = message.comments[commentIndex];
			if (!comment) return;
			
			const result = await ProjectMessagesService.deleteComment(message.id_doc, comment.id_doc);
			if (result) {
				message.comments = message.comments.filter(c => c.id_doc !== comment.id_doc);
			}
		},
		async updateMessage(messageIndex) {
			if (!this.editedMessage.trim()) return;
			
			let message = this.messages[messageIndex];
			if (!message) return;
			
			const [status, responseSave] = await ProjectMessagesService.updateMessage(message.id_doc, this.editedMessage.trim());
			if (status) {
				this.messages[messageIndex] = {
					...message,
					message: this.editedMessage.trim(),
					updated_at: responseSave.updated_at,
					formatted_updated_at: this.formatDateOnMessages(responseSave.updated_at)
				};
			}
		},
		async updateComment(messageIndex, commentIndex) {
			if (!this.editedComment.trim()) return;
			
			const message = this.messages[messageIndex];
			if (!message || !message.comments) return;
			
			const comment = message.comments[commentIndex];
			if (!comment) return;
			
			const [status, responseSave] = await ProjectMessagesService.updateComment(message.id_doc, comment.id_doc, this.editedComment.trim());
			if (status) {
				message.comments[commentIndex] = {
					...comment,
					comment: this.editedComment.trim(),
					updated_at: responseSave.updated_at,
					formatted_updated_at: this.formatDateOnMessages(responseSave.updated_at)
				};
			}
		},
		openMessagesDialog() {
			this.show_messages_dialog = true;
		},
		openCommentDialog(projectId) {
			this.show_comment_dialog = true;
		},
		closeMessagesDialog() {
			this.show_messages_dialog = false;
			this.messagesDialog = false;
			this.is_loading_modal_messages = false;
			this.messages = [];
			this.lastDocSnapshot = null;
			this.resetInfiniteHandler = true;
		},
		updateProjects(Action){
			const project = this.items.find((({id_doc}) => id_doc === Action.projectId))
			project.currentStatusFranchisee = Action.project.currentStatusFranchisee
			project.currentStatusADM = Action.project.currentStatusADM
		}
	},

	async created() {
		let status, projectList
		if(this.getCurrentUserRank == "Super Admin" || this.getCurrentUserRank == "Admin")[status, projectList] = await ProjectsService.getProjectWithUf()
		else[status, projectList] = await ProjectsService.getProjects()
		const response = await UsersService.findAllFranchisee()
		this.franchisee_list = []
		this.project_franchisee_list = []

		if (response.status == 200) {
			this.franchisee_list = [
				{
					id: 'general',
					name: 'Geral',
				},
				...response.data.data
			]
			this.project_franchisee_list = response.data.data
		} else {
			showErrorSnackBar("Ocorreu um erro na busca da lista de franqueados")
		}
		this.franchisee_list = this.franchisee_list.map(({ id, name }) => ({ id, name }))
		if (this.franchisee_list.length > 0) {
			this.franchisee_list = [
				/* this was duplicated
				{
					id: 'general',
					name: 'Geral',
				},
				*/
				...this.franchisee_list
			]
			this.franchisee_selected = {
				id: 'general',
				name: 'Geral',
			}
		}
		this.items = projectList.map(
			(project) => {
				let created_at = new Date(project.created_at._seconds * 1000)
				let currentHourStatusFranchisee = project.currentHourStatusFranchisee 
				let currentHourStatusADM = project.currentHourStatusADM
				let now = new Date();
				let daysPassed = Math.floor((now-created_at) / (1000 * 60 * 60 * 24));
				let franchisee = this.franchisee_list.find(item => item.id === project.id_franchisee);
				return {
					...project, 
					created_at,
					created_at_formatted: new Date(created_at).getTime(),
					date_formatted_franchisee: currentHourStatusFranchisee ? new Date(currentHourStatusFranchisee).getTime(): '',
					date_formatted_adm: currentHourStatusADM ? new Date(currentHourStatusADM).getTime(): '',
					running_time: daysPassed,
					has_message: project?.readers && !project.readers.some(reader => reader.reader_id === this.getCurrentUserData.id),
					currentStepFormatted: this.checkCurrentStep(project.steps),
					...(this.isFranchisee ? {} : { franchisee_name: franchisee?.name ? franchisee.name : 'Não definido' }),
				}
			}
		)

		this.initializeFiltersFromURL();
		this.is_created = true
		this.is_loading = false
	},
	watch: {
		searchField: {
			handler: function() {
				if (this.searchField !== this.$route.query.searchText) {
					this.updateURLFilters();
				}
			}
		},
		searchOptionSelected: {
			handler: function() {
				if (this.searchOptionSelected !== this.$route.query.searchOption) {
					this.updateURLFilters();
				}
			}
		},
		selectedChips: {
			handler: function() {
				if (this.selectedChips.join(',') !== this.$route.query.steps) {
					this.updateURLFilters();
				}
			},
			deep: true
		},
		startDatePicker: {
			handler: function() {
				if (this.startDatePicker.join(',') !== this.$route.query.startDate) {
					this.updateURLFilters();
				}
			},
			deep: true
		}
	},
};